import React from "react";
import {
	SubscribeBoxMainWrapper,
	SubscribeBoxName,
	SubscribeBoxWrapper,
	SubscribeChangeButton,
	SubscribeContent,
	SubscribeDateContent,
	SubscribeDateDeadline,
	SubscribeDateTitle,
	SubscribeDateWrapper,
	SubscribeDescriptionContent,
	SubscribeDescriptionIcon,
	SubscribeDescriptionWrapper,
	SubscribeInfoWrapper,
	SubscribeTitle,
	SubscribeTitleWrapper,
} from "./style";
import WarningIcon from "@/assets/img/ic_warning.svg";
import { useSelector } from "react-redux";
import { getCurrentPlan } from "@/redux/organization/selector";
import { Skeleton } from "@mui/material";
import { format } from "date-fns";
import { ko } from "date-fns/locale";

interface SubscribeBoxProps {
	className?: string;
}

export default function SubscribeBox({ className }: SubscribeBoxProps) {
	const currentPlan = useSelector(getCurrentPlan);

	return (
		<SubscribeBoxWrapper className={className}>
			<SubscribeBoxName>요금제</SubscribeBoxName>
			<SubscribeBoxMainWrapper>
				<SubscribeContent>
					<SubscribeTitleWrapper
						disabledBorder={Boolean(!currentPlan?.paymentPlan)}
					>
						<SubscribeTitle>
							{currentPlan ? (
								currentPlan.paymentPlan?.title || "플랜 등록 필요"
							) : (
								<Skeleton height={34} />
							)}
						</SubscribeTitle>
						{currentPlan ? (
							<SubscribeChangeButton
								variant="contained"
								backgroundColor="#0071E3"
								link="/price"
							>
								변경
							</SubscribeChangeButton>
						) : (
							<Skeleton width={66} height={34} />
						)}
					</SubscribeTitleWrapper>
				</SubscribeContent>

				{currentPlan ? (
					<SubscribeInfoWrapper>
						{currentPlan.paymentPlan?.endAt && (
							<SubscribeDateWrapper>
								<SubscribeDateTitle>유효기간</SubscribeDateTitle>
								<SubscribeDateContent>
									{format(
										new Date(currentPlan.paymentPlan.endAt),
										"yyyy년 MM월 dd일 a hh:mm",
										{
											locale: ko,
										},
									)}
								</SubscribeDateContent>
								<SubscribeDateDeadline>
									{currentPlan.paymentPlan.remainingDays}일 남음
								</SubscribeDateDeadline>
							</SubscribeDateWrapper>
						)}
						{currentPlan.paymentPlan?.planType === "welcome" && (
							<SubscribeDescriptionWrapper>
								<SubscribeDescriptionIcon src={WarningIcon} />
								<SubscribeDescriptionContent>
									이 조직은 무료 평가판이 만료되면 비활성화되며 모든
									데이터는 6개월 후에 삭제됩니다. Foodlens서비스를 계속
									사용하려면 무료 평가판이 종료되기 전에 요금제를
									변경하세요.
								</SubscribeDescriptionContent>
							</SubscribeDescriptionWrapper>
						)}
					</SubscribeInfoWrapper>
				) : (
					<Skeleton
						width="calc(100% - 34px)"
						height={200}
						sx={{ marginTop: "20px" }}
					/>
				)}
			</SubscribeBoxMainWrapper>
		</SubscribeBoxWrapper>
	);
}
